import type { RouteObject } from 'react-router-dom'
import type { NavItem } from '@/app/registry'
import { AccountsPage } from './AccountsPage'
import { AdminAiPage } from './AdminAiPage'
import { AdminSettingsPage } from './AdminSettingsPage'

export const routes: RouteObject[] = [
  { path: '/admin/users', element: <AccountsPage /> },
  { path: '/admin/ai', element: <AdminAiPage /> },
  { path: '/admin/settings', element: <AdminSettingsPage /> },
]
export const nav: NavItem[] = [
  { path: '/admin', label: 'Администрирование', icon: 'shield', mobile: 'more', order: 95 },
  { path: '/admin/users', label: 'Пользователи', icon: 'user', mobile: null, order: 10, parent: '/admin' },
  { path: '/admin/ai', label: 'ИИ', icon: 'ai', mobile: null, order: 20, parent: '/admin' },
  { path: '/admin/settings', label: 'Настройки сервиса', icon: 'settings', mobile: null, order: 30, parent: '/admin' },
]
